var form_submitted = false;

function checkFormSubmission($mainForm) {
  var targetNode = $('.hidden-form .klaviyo_messages');
  if (targetNode.length === 0) {
    return;
  }
  var config = { attributes: true, subtree: true };

  var callback = function(mutationsList) {
      for(var mutation of mutationsList) {
        if (mutation.type == 'attributes') {
          observer.disconnect();
          form_submitted = true;
          $mainForm.trigger('submit');
        }
      }
  };

  var observer = new MutationObserver(callback);
  observer.observe(targetNode[0], config);
}

function registerForm(){
  $('#create_customer').on('submit', function(e) {
    let $this = $(this);
    let newsletterCheck = $this.find('input[name="newsletter"]');
    let $pass = $this.find('.pass');
    let $passConfirm = $this.find('.password-confirm');

    if ($pass.val() !== $passConfirm.val() && $pass.val() != '') {
      e.preventDefault();
      $pass.add($passConfirm).addClass('error');
    }else{
      if (newsletterCheck.prop('checked') && !form_submitted) {
        e.preventDefault();
        checkFormSubmission($this);
        let $newsletterForm = $('.hidden-form form');
        let emailVal = $this.find('input[name="customer[email]"]').val();
        $newsletterForm.find('input[name="email"]').val(emailVal)
        $newsletterForm.find('.klaviyo_submit_button').trigger('click');
      }
    }
  });
}

export default registerForm();



// WEBPACK FOOTER //
// ../markup/assets/js/account-login-register.js